import React, {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import VehicleStatusDropdownComponent from "../common/vehicle-status-dropdown.component";
import useVehicle from "../hooks/useVehicle";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import {useLocation} from "react-router-dom";
import CustomTextField from "../../../core/components/ui/CustomTextfield";


const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedVehicle} = props;

    const location = useLocation();

    const {isUpdatingVehicleStatus, updateVehicleStatus} = useVehicle();

    const [selectedStatus, setSelectedStatus] = useState(selectedVehicle?.status);
    const [reasonInput, setReasonInput] = useState(selectedVehicle?.purpose || "");

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");


    const handleTextfieldChange = (e) => {
        setReasonInput(e.target.value);
    }

    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;
        const reasonForStatus = (selectedStatus !== "Active") ? reasonInput : " ";

        if (organizationId) {
            const parameters = {
                vehicleUID: selectedVehicle?.vehicle_uid,       
                status: selectedStatus,
                orgUID: organizationId,
                purpose: reasonForStatus
            }

            updateVehicleStatus(parameters);

        } else {
            const parameters = {
                vehicleUid: selectedVehicle?.vehicle_uid,       
                status: selectedStatus,
                purpose: reasonForStatus
            }

            updateVehicleStatus(parameters);
        }
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (!selectedStatus || isUpdatingVehicleStatus || (selectedStatus !== "Active" && !reasonInput.trim())) ? null : handleUpdateStatus(e),
            customStyles: {
                opacity: (!selectedStatus || isUpdatingVehicleStatus || (selectedStatus !== "Active" && !reasonInput.trim())) ? "55%" : "100%",
                cursor: (!selectedStatus || isUpdatingVehicleStatus || (selectedStatus !== "Active" && !reasonInput.trim())) ? "not-allowed !important" : "pointer",
                visibility: (isUpdatingVehicleStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingVehicleStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage vehicle status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingVehicleStatus) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating vehicle status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 2 : 1
                                    }}
                                />

                                <VehicleStatusDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>

                                {selectedStatus !== "Active" && 
                                    <>
                                        <CustomTypography 
                                            variant="subtitle2"
                                            text={"Reason"}
                                            customStyles={{}}
                                        />
                                        <CustomTextField 
                                            placeholder={"Enter reason"}
                                            variant={"outlined"}
                                            value={reasonInput}
                                            onChange={(e) => handleTextfieldChange(e)}
                                            fullWidth={true}
                                            multiline={false}
                                            hiddenLabel
                                            readOnly={isUpdatingVehicleStatus}
                                        /> 
                                    </>   
                                }
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingVehicleStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
